/* eslint-disable import/prefer-default-export */

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DAY_FORMAT = 'dddd';
export const WEEK_FORMAT = 'YYYY-wo';
export const WEEK_NUMBER_FORMAT = 'w';
export const MONTH_FORMAT = 'MMM';
export const YEAR_FORMAT = 'YYYY';
